import React from 'react';
import { createRoot } from 'react-dom/client';
import { configReady } from './auth/config';
import App from './App';
import './index.css';

// Amplify must be configured before any auth calls are made.
// configReady resolves once the config is loaded (from .env.local in dev,
// or from /config.json fetched at runtime in deployed environments).
configReady
  .then(() => {
    const root = document.getElementById('root')!;
    createRoot(root).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  })
  .catch((err) => {
    console.error('Failed to initialise app config:', err);
    document.body.innerHTML =
      '<div style="font-family:sans-serif;padding:2rem;color:#dc2626">Failed to load application config. Please try again.</div>';
  });
